import { createSlice } from '@reduxjs/toolkit';

export const pathContextInitialState = {
  baseUrl: '',
};

// Then, handle actions in your reducers:
const pathContextSlice = createSlice({
  name: 'pathContext',
  pathContextInitialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    pathContextSetBaseUrlState: (state, { payload }) => {
      state.baseUrl = payload;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { pathContextSetBaseUrlState } = pathContextSlice.actions;

// The reducer
export const pathContextReducer = pathContextSlice.reducer;
